import Auth from 'j-toker';
import { apiGet, apiPutMultipart, apiPostMultipart, apiDelete } from 'helpers/ApiHelper';
import * as types from './actionTypes';
import { showFailure } from 'actions/notificationActions';

const makeUrl = path => Auth.getApiUrl() + '/landlords' + path;

export function createEvent(data) {
  return () => {
    let multiPartFormData = new FormData();

    if (data.photo.lastModified) {
      multiPartFormData.append('photo', data.photo);
    }

    // changing the proeprty field name to property_ids so that backend can query the properties
    data['property_ids'] = data['properties'];

    const formData = JSON.stringify(data);

    multiPartFormData.append('data', formData);

    return apiPostMultipart(makeUrl('/site_events'), multiPartFormData);
  };
}

export function editEvent(data, eventId) {
  return dispatch => {
    dispatch({ type: types.EDIT_EVENT });

    let multiPartFormData = new FormData();

    if (data.photo.lastModified) {
      multiPartFormData.append('photo', data.photo);
    }

    data['property_ids'] = data['properties']; // TODO: when property multiselect is addeed, please move to here

    const formData = JSON.stringify(data);
    multiPartFormData.append('data', formData);

    return apiPutMultipart(makeUrl(`/site_events/${eventId}`), multiPartFormData);
  };
}

export function deleteEvent(eventType, eventId) {
  return dispatch => {
    dispatch({ type: types.DELETE_EVENT });

    return apiDelete(makeUrl(`/site_events/${eventType}/${eventId}`));
  };
}

export function getEvent(eventType, eventId) {
  return dispatch =>
    dispatch({
      type: types.FETCH_EVENT,
      payload: apiGet(makeUrl(`/site_event/${eventType}/${eventId}`)).catch(error => {
        dispatch(showFailure(error));
      }),
    });
}
